export default function () {
  const recaptchaSiteKey = window.recaptchaSiteKey;
  const grecaptcha = window.grecaptcha;

  console.log('reCAPTCHA site key:', recaptchaSiteKey);
  console.log('greCAPTCHA', grecaptcha);

  if (typeof grecaptcha !== 'undefined' && grecaptcha.ready) {
    grecaptcha.ready(() => {
      grecaptcha.execute(recaptchaSiteKey, {action: 'contact'})
        .then(token => {
          console.log('Token received:', token ? 'yes' : 'no');
          document.querySelectorAll('.recaptcharesponse')
            .forEach(elem => elem.value = token);
        })
        .catch(err => console.error('reCAPTCHA execution error:', err));
    });
  } else {
    console.warn('reCAPTCHA not available');
  }
}



// WEBPACK FOOTER //
// ./scripts/components/recaptcha-init.js